// Statistics Knowledge Graph Samples - Part 1
// Organized by difficulty levels with systematic naming

export const statisticsSamplesPart1 = {
  fundamental: [
    {
      id: 'stats_fund_01',
      problem: "Find the mean, median, and standard deviation of the data set: 2, 4, 6, 8, 10",
      problemType: "statistics",
      difficulty: "fundamental",
      description: "Basic statistics with simple data set",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "2, 4, 6, 8, 10",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_formula",
            name: "Mean Formula",
            type: "formulas",
            description: "Mean = Sum of all values ÷ Number of values",
            value: "Mean = (2+4+6+8+10) ÷ 5",
            importance: 10,
            x: -150, y: 0, z: 25
          },
          {
            id: "median_formula",
            name: "Median Formula",
            type: "formulas",
            description: "Median = Middle value when data is ordered",
            value: "Median = middle value of ordered data",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "standard_deviation_formula",
            name: "Standard Deviation Formula",
            type: "formulas",
            description: "σ = √(Σ(x - μ)²/n)",
            value: "σ = √(Σ(x - μ)²/n)",
            importance: 10,
            x: 150, y: 0, z: 25
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 6",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 6",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 2.83",
            importance: 9,
            x: 120, y: 150, z: -15
          },
          {
            id: "identify_data",
            name: "Identify Data",
            type: "steps",
            description: "Extract the data set from the problem",
            value: "Step 1: Data = [2, 4, 6, 8, 10]",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_mean",
            name: "Calculate Mean",
            type: "steps",
            description: "Find the average of all values",
            value: "Step 2: Mean = (2+4+6+8+10)/5 = 6",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "find_median",
            name: "Find Median",
            type: "steps",
            description: "Find the middle value",
            value: "Step 3: Median = 6 (middle value)",
            importance: 8,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculate_std_dev",
            name: "Calculate Standard Deviation",
            type: "steps",
            description: "Find the standard deviation",
            value: "Step 4: σ = √(Σ(x-6)²/5) = 2.83",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "mean_formula",
            name: "Mean Formula",
            type: "formulas",
            description: "Arithmetic mean of a data set",
            value: "Mean = (Σx)/n",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "median_formula",
            name: "Median Formula",
            type: "formulas",
            description: "Middle value of ordered data set",
            value: "Median = middle value when n is odd",
            importance: 8,
            x: 0, y: -100, z: 20
          },
          {
            id: "standard_deviation_formula",
            name: "Standard Deviation Formula",
            type: "formulas",
            description: "Measure of data spread",
            value: "σ = √(Σ(x-μ)²/n)",
            importance: 9,
            x: 150, y: -100, z: 20
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "central_tendency", to: "mean_formula", type: "uses", strength: 9 },
          { from: "central_tendency", to: "median_formula", type: "uses", strength: 8 },
          { from: "variability", to: "standard_deviation_formula", type: "uses", strength: 9 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 },
          { from: "statistics", to: "identify_data", type: "requires", strength: 8 },
          { from: "identify_data", to: "calculate_mean", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "find_median", type: "enables", strength: 8 },
          { from: "find_median", to: "calculate_std_dev", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "mean_result", type: "produces", strength: 9 },
          { from: "find_median", to: "median_result", type: "produces", strength: 8 },
          { from: "calculate_std_dev", to: "standard_deviation_result", type: "produces", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_fund_02',
      problem: "Find the mean, median, and standard deviation of the data set: 1, 3, 5, 7, 9",
      problemType: "statistics",
      difficulty: "fundamental",
      description: "Basic statistics with odd number of values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "1, 3, 5, 7, 9",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 5",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 5",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 2.83",
            importance: 9,
            x: 120, y: 150, z: -15
          },
          {
            id: "mean_formula",
            name: "Mean Formula",
            type: "formulas",
            description: "Arithmetic mean of a data set",
            value: "Mean = (Σx)/n",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "median_formula",
            name: "Median Formula",
            type: "formulas",
            description: "Middle value of ordered data set",
            value: "Median = middle value when n is odd",
            importance: 8,
            x: 0, y: -100, z: 20
          },
          {
            id: "standard_deviation_formula",
            name: "Standard Deviation Formula",
            type: "formulas",
            description: "Measure of data spread",
            value: "σ = √(Σ(x-μ)²/n)",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "identify_data",
            name: "Identify Data",
            type: "steps",
            description: "Extract the data set from the problem",
            value: "Step 1: Data = [1, 3, 5, 7, 9]",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_mean",
            name: "Calculate Mean",
            type: "steps",
            description: "Find the average of all values",
            value: "Step 2: Mean = (1+3+5+7+9)/5 = 5",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "find_median",
            name: "Find Median",
            type: "steps",
            description: "Find the middle value",
            value: "Step 3: Median = 5 (middle value)",
            importance: 8,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculate_std_dev",
            name: "Calculate Standard Deviation",
            type: "steps",
            description: "Find the standard deviation",
            value: "Step 4: σ = √(Σ(x-5)²/5) = 2.83",
            importance: 9,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "central_tendency", to: "mean_formula", type: "uses", strength: 9 },
          { from: "central_tendency", to: "median_formula", type: "uses", strength: 8 },
          { from: "variability", to: "standard_deviation_formula", type: "uses", strength: 9 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 },
          { from: "statistics", to: "identify_data", type: "requires", strength: 8 },
          { from: "identify_data", to: "calculate_mean", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "find_median", type: "enables", strength: 8 },
          { from: "find_median", to: "calculate_std_dev", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "mean_result", type: "produces", strength: 9 },
          { from: "find_median", to: "median_result", type: "produces", strength: 8 },
          { from: "calculate_std_dev", to: "standard_deviation_result", type: "produces", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_fund_03',
      problem: "Find the mean, median, and standard deviation of the data set: 3, 6, 9, 12, 15",
      problemType: "statistics",
      difficulty: "fundamental",
      description: "Basic statistics with arithmetic sequence",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "3, 6, 9, 12, 15",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 9",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 9",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 4.24",
            importance: 9,
            x: 120, y: 150, z: -15
          },
          {
            id: "mean_formula",
            name: "Mean Formula",
            type: "formulas",
            description: "Arithmetic mean of a data set",
            value: "Mean = (Σx)/n",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "median_formula",
            name: "Median Formula",
            type: "formulas",
            description: "Middle value of ordered data set",
            value: "Median = middle value when n is odd",
            importance: 8,
            x: 0, y: -100, z: 20
          },
          {
            id: "standard_deviation_formula",
            name: "Standard Deviation Formula",
            type: "formulas",
            description: "Measure of data spread",
            value: "σ = √(Σ(x-μ)²/n)",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "identify_data",
            name: "Identify Data",
            type: "steps",
            description: "Extract the data set from the problem",
            value: "Step 1: Data = [3, 6, 9, 12, 15]",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_mean",
            name: "Calculate Mean",
            type: "steps",
            description: "Find the average of all values",
            value: "Step 2: Mean = (3+6+9+12+15)/5 = 9",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "find_median",
            name: "Find Median",
            type: "steps",
            description: "Find the middle value",
            value: "Step 3: Median = 9 (middle value)",
            importance: 8,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculate_std_dev",
            name: "Calculate Standard Deviation",
            type: "steps",
            description: "Find the standard deviation",
            value: "Step 4: σ = √(Σ(x-9)²/5) = 4.24",
            importance: 9,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "central_tendency", to: "mean_formula", type: "uses", strength: 9 },
          { from: "central_tendency", to: "median_formula", type: "uses", strength: 8 },
          { from: "variability", to: "standard_deviation_formula", type: "uses", strength: 9 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 },
          { from: "statistics", to: "identify_data", type: "requires", strength: 8 },
          { from: "identify_data", to: "calculate_mean", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "find_median", type: "enables", strength: 8 },
          { from: "find_median", to: "calculate_std_dev", type: "enables", strength: 9 },
          { from: "calculate_mean", to: "mean_result", type: "produces", strength: 9 },
          { from: "find_median", to: "median_result", type: "produces", strength: 8 },
          { from: "calculate_std_dev", to: "standard_deviation_result", type: "produces", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_fund_04',
      problem: "Find the mean, median, and standard deviation of the data set: 4, 8, 12, 16, 20",
      problemType: "statistics",
      difficulty: "fundamental",
      description: "Basic statistics with larger values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "4, 8, 12, 16, 20",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 12",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 12",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 5.66",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_fund_05',
      problem: "Find the mean, median, and standard deviation of the data set: 5, 10, 15, 20, 25",
      problemType: "statistics",
      difficulty: "fundamental",
      description: "Basic statistics with multiples of 5",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "5, 10, 15, 20, 25",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 15",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 15",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 7.07",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    }
  ],
  
  intermediate: [
    {
      id: 'stats_inter_01',
      problem: "Find the mean, median, and standard deviation of the data set: 1, 2, 3, 4, 5, 6, 7",
      problemType: "statistics",
      difficulty: "intermediate",
      description: "Statistics with 7 values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "1, 2, 3, 4, 5, 6, 7",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 4",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 4",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 2",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_inter_02',
      problem: "Find the mean, median, and standard deviation of the data set: 2, 4, 6, 8, 10, 12, 14, 16",
      problemType: "statistics",
      difficulty: "intermediate",
      description: "Statistics with 8 values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "2, 4, 6, 8, 10, 12, 14, 16",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 9",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 9",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 4.47",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_inter_03',
      problem: "Find the mean, median, and standard deviation of the data set: 1, 3, 5, 7, 9, 11, 13, 15, 17",
      problemType: "statistics",
      difficulty: "intermediate",
      description: "Statistics with 9 values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "1, 3, 5, 7, 9, 11, 13, 15, 17",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 9",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 9",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 5.66",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_inter_04',
      problem: "Find the mean, median, and standard deviation of the data set: 5, 10, 15, 20, 25, 30, 35, 40, 45, 50",
      problemType: "statistics",
      difficulty: "intermediate",
      description: "Statistics with 10 values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "5, 10, 15, 20, 25, 30, 35, 40, 45, 50",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 27.5",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 27.5",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 14.43",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    },
    {
      id: 'stats_inter_05',
      problem: "Find the mean, median, and standard deviation of the data set: 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22",
      problemType: "statistics",
      difficulty: "intermediate",
      description: "Statistics with 11 values",
      graphData: {
        nodes: [
          {
            id: "statistics",
            name: "Statistics",
            type: "concepts",
            description: "Collection, analysis, and interpretation of data",
            value: "Data analysis and interpretation",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "central_tendency",
            name: "Central Tendency",
            type: "concepts",
            description: "Measures that describe the center of a data set",
            value: "Mean, median, mode",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "variability",
            name: "Variability",
            type: "concepts",
            description: "Measures that describe the spread of data",
            value: "Variance, standard deviation, range",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "data_set",
            name: "Data Set",
            type: "values",
            description: "The given data values",
            value: "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22",
            importance: 10,
            x: 0, y: 60, z: 35
          },
          {
            id: "mean_result",
            name: "Mean Result",
            type: "values",
            description: "The mean of the data set",
            value: "Mean = 12",
            importance: 9,
            x: -120, y: 150, z: -15
          },
          {
            id: "median_result",
            name: "Median Result",
            type: "values",
            description: "The median of the data set",
            value: "Median = 12",
            importance: 8,
            x: 0, y: 150, z: -15
          },
          {
            id: "standard_deviation_result",
            name: "Standard Deviation Result",
            type: "values",
            description: "The standard deviation of the data set",
            value: "σ = 6.32",
            importance: 9,
            x: 120, y: 150, z: -15
          }
        ],
        links: [
          { from: "statistics", to: "central_tendency", type: "includes", strength: 9 },
          { from: "statistics", to: "variability", type: "includes", strength: 8 },
          { from: "data_set", to: "mean_result", type: "used to calculate", strength: 9 },
          { from: "data_set", to: "median_result", type: "used to calculate", strength: 8 },
          { from: "data_set", to: "standard_deviation_result", type: "used to calculate", strength: 9 }
        ]
      }
    }
  ]
}; 